<div class="visualizar-questionario-modal__overlay" (click)="onFechar()">
  <div
    class="visualizar-questionario-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="visualizar-questionario-modal-title"
    data-testid="visualizar-questionario-modal"
    (click)="$event.stopPropagation()"
  >
    <div class="visualizar-questionario-modal__header">
      <h2 id="visualizar-questionario-modal-title" class="visualizar-questionario-modal__title">
        Visualizar questionário
      </h2>
      <button
        type="button"
        class="visualizar-questionario-modal__close"
        aria-label="Fechar"
        (click)="onFechar()"
        data-testid="visualizar-questionario-modal-close"
      >
        ×
      </button>
    </div>

    <app-questionario-conteudo [questionario]="questionario()" />
  </div>
</div>
